import { gql } from '@apollo/client'

export const GET_PERSON_TAGS = gql`
  query GetPersonTags($payload: PersonTagsPayload) {
    personTags(payload: $payload) {
      id
      is_active
      tag {
        id
        name
      }
    }
  }
`
export const GET_TAGS = gql`
  query GetAllTags {
    tags {
      id
      name
      is_active
    }
  }
`
